export default "__VITE_ASSET__BKkGjuCp__"